/**
 * Image URL Helper
 * Handles legacy S3 URLs, local filenames, and Replit App Storage keys
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get full image URL from storage key, filename, or URL
 * @param {string} imageSource - Can be either:
 *   - Full S3 URL (legacy): "https://bucket.s3.region.amazonaws.com/path/file.webp"
 *   - Storage key: "providers/user-id/gallery/gallery_abc123.webp"
 *   - Legacy filename: "gallery_abc123.webp"
 * @returns {string} Full image URL
 */
export const getImageUrl = (imageSource) => {
  if (!imageSource) {
    return null;
  }

  // If it's already a full URL (legacy S3), return as-is
  if (imageSource.startsWith('http://') || imageSource.startsWith('https://')) {
    return imageSource;
  }

  // For storage keys and local filenames, use our media serving API endpoint
  return `${BACKEND_URL}/api/media/${imageSource}`;
};

/**
 * Get image URLs from array of sources
 * @param {string[]} imageSources - Array of filenames or URLs
 * @returns {string[]} Array of full URLs
 */
export const getImageUrls = (imageSources) => {
  if (!imageSources || !Array.isArray(imageSources)) {
    return [];
  }

  return imageSources.map(getImageUrl).filter(Boolean);
};

/**
 * Check if image source is a full URL (legacy S3 URL)
 * @param {string} imageSource
 * @returns {boolean}
 */
export const isExternalUrl = (imageSource) => {
  if (!imageSource) return false;
  return imageSource.startsWith('http://') || imageSource.startsWith('https://');
};

// Alias for backwards compatibility
export const isS3Url = isExternalUrl;

export default {
  getImageUrl,
  getImageUrls,
  isExternalUrl,
  isS3Url
};
